<template>
  <div class="bg-white col full-width">
    <div class="desktop-single-column q-px-md">
      <ClaimSubmitted
        :class="['q-mt-lg', { 'bdr-a-grey-4 rounded-borders': !isMobile }]"
        :img="images.claimSubmitted"
        v-if="submitted"
        :is-mobile="isMobile"
        @restart="$emit('restart')"
        @close="$emit('close')"
      />
      <div v-else :class="{ 'q-pb-lg': isMobile }">
        <BtnBack class="q-my-md" @click="$emit('close')" />
        <div
          :class="{
            'q-pa-lg rounded-borders-lg bdr-a-grey-4 q-mb-lg': !isMobile
          }"
        >
          <h4 class="text-grey-10 text-weight-medium q-mb-lg">
            Make a claim
          </h4>

          <div :class="isMobile ? 'column' : 'row q-col-gutter-lg'">
            <div class="col">
              <p class="text-weight-bold q-mb-sm">Paying into</p>
              <div class="q-mb-lg row">
                <div class="col" v-if="accountEndingIn">
                  Account ending in {{ accountEndingIn }}
                </div>
                <SAILink
                  class="cursor-pointer"
                  :disable="saving || submitted"
                  :label="accountEndingIn ? 'Change' : 'Add'"
                  @click="$emit('open:bank-details')"
                />
                <p class="text-body text-negative full-width q-mt-sm" v-if="bankDetailsError">{{ bankDetailsError }}</p>
              </div>
              <p class="text-weight-bold q-mb-sm">This claim is for</p>
              <div class="row q-gutter-sm scroll q-mb-lg">
                <div v-for="lease in leases" :key="lease.id">
                  <SAICardToggle
                    :error="errors.payload.leaseId.$error"
                    :disable="saving || submitted"
                    :active="leaseId === lease.id"
                    @click="$emit('select:lease', lease.id)"
                  >
                    <p
                      class="text-weight-medium q-py-sm q-px-lg text-capitalize"
                    >
                      {{ lease.vehicleRego }}
                    </p>
                  </SAICardToggle>
                </div>
              </div>
              <p class="text-weight-bold q-mb-sm">Expense Type*</p>
              <div class="row q-mb-lg">
                <BtnToggleRound
                  class="col-6 q-mb-md"
                  v-for="type in claimTypes"
                  :key="type.value"
                  :error="errors.payload.claimType.$error"
                  :active="type.value === claimType"
                  :disable="saving || submitted"
                  :icon="type.icon"
                  :label="type.label"
                  @click="$emit('select:claim-type', type.value)"
                />
              </div>
              <div class="q-mb-sm">
                <span class="text-paragraph text-weight-bold q-mr-xs">
                  Total Amount*
                </span>
                <span>(inc GST)</span>
              </div>
              <SAIInput
                :error="errors.payload.amountTotal.$error"
                :class="{ 'q-mb-lg': isMobile }"
                placeholder="0"
                prefix="$"
                type="number"
                :value="amount"
                :disable="saving || submitted"
                @input="$emit('update:amount', $event)"
              />
            </div>

            <div class="col">
              <p class="text-body">
                Please upload the receipts of your payment. Make sure it is
                clear and shows the paid date and amount.
              </p>
              <SAIFileDisplay
                :value="files"
                :error="errors.files.$error"
                class="q-mb-lg q-mt-sm"
                placeholder="Upload Files"
                v-bind="fileRequirements"
                multiple
                :disable="saving || submitted"
                @input="$emit('update:files', $event)"
              />
              <p class="text-weight-bold q-mb-sm">Your Agreement</p>
              <p class="text-body">
                By submitting this claim I acknowledge the information I have
                provided is true and correct. I understand and agree to the
                Terms and Conditions and to the handling of my personal
                information in accordance with {{ entity }} Privacy Policy.
                <br />
                <br />
                Don’t forget to keep your original receipts for 3 years for
                audit purposes, unless you have attached clear receipts with
                this claim.
              </p>
              <SAIBtn
                :class="['q-mt-lg', { 'full-width': isMobile }]"
                size="16px"
                no-caps
                padding="15px 48px"
                :loading="saving"
                @click="$emit('submit')"
              >
                <p class="text-weight-medium">Submit</p>
              </SAIBtn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  SAICardToggle,
  SAIInput,
  SAIFileDisplay,
  SAIBtn,
  SAILink
} from 'ecx.saigon.ui.common';

export default {
  name: 'ClaimsNew',
  props: {
    isMobile: Boolean,
    entity: String,
    saving: Boolean,
    submitted: Boolean,
    leases: {
      type: Array,
      default: () => []
    },
    claimTypes: {
      type: Array,
      default: () => []
    },
    leaseId: String,
    amount: Number,
    claimType: String,
    accountEndingIn: String,
    files: {
      type: Array,
      default: () => []
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    images: {
      type: Object,
      default: () => ({})
    },
    fileRequirements: {
      type: Object,
      default: () => ({})
    },
    bankDetailsError: String
  },
  components: {
    SAICardToggle,
    SAIInput,
    SAIFileDisplay,
    SAIBtn,
    SAILink,
    BtnBack: () => import('../../atom/btn-back'),
    ClaimSubmitted: () => import('../../molecule/claim-submitted'),
    BtnToggleRound: () => import('../../atom/btn-toggle-round')
  }
};
</script>
